import { Component, Input, ViewChild, ViewContainerRef, OnInit, EnvironmentInjector, computed, signal, effect } from '@angular/core';
import { RmsModule } from '../../custom-modules/rms-module/rms.module';

@Component({
  selector: 'app-grid-item',
  imports: [RmsModule],
  standalone: true,
  template: `
<div class="gridContainer" [class.editable]="editable">
<div class="gi-header drag-handle">
  <div class="gi-title">{{ title }}</div>
  <div class="gi-actions">
    <button  *ngIf="editable" mat-icon-button [attr.aria-label]="'Remove '+title" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div class="gi-content"><ng-container #host></ng-container></div>
</div>
`,
  styles: [
    `:host{display:block;height:100%;min-height:0}.gi-content{flex:1;min-height:0;overflow:auto}.gi-header{flex-shrink:0;min-height:32px}.editable .gi-header{cursor:grab}.gi-actions button{padding:0!important;margin:0;width:28px;height:28px}.gridContainer{box-sizing:border-box;border:1px solid #dce4eb}`,

    `.gridContainer{height:100%;width:100%;display:flex;flex-direction:column;background:var(--grid-item-bg,#fff);border-radius:12px;box-shadow:1px 1px 5px rgba(0,0,0,.05);overflow:hidden}`,
    `.gridContainer.editable{box-shadow:5px 5px 4px rgba(0,0,0,.3);outline:1px dashed rgba(0,148,216,.4)}`,
    `.gi-header{display:flex;align-items:center;justify-content:space-between;padding:6px 8px;background:#f7f9fb;border-bottom:1px solid #dfe8f1}`,
    `.gi-title{font-weight:600;font-size:12px;color:#19384f}`,
  ]
})
export class GridItemComponent implements OnInit {
  @Input({ required: true }) componentType!: any;
  @Input() onRemove!: () => void;
  @Input() editable = false;
  @Input() title = '';
  @Input() data: any;


  @ViewChild('host', { read: ViewContainerRef, static: true }) host!: ViewContainerRef;


  constructor(private injector: EnvironmentInjector) { }


  ngOnInit() {
    this.host.clear();
    if (!this.componentType) return;
    const ref = this.host.createComponent(this.componentType, {
      environmentInjector: this.injector
    });
    if (this.data && ref.instance) Object.assign(ref.instance, this.data);
  }


  onClose() { if (this.onRemove) this.onRemove(); }
}
